import React from 'react';
import _ from 'underscore';

import {ExtensionsSettingsCoordinator} from '~src/settings/general-settings/components/extensions-settings/ExtensionsSettingsCoordinator';
import {subspaceStyle} from '~src/settings/styles/CommonStyles';

import {SessionManagementService} from '../../../sessionManagement/SessionManagementService';
import {FeatureFlags} from '../../../ts/FeatureFlags';
import {RouterError} from '../RouterHelpers/RouterError';
import { ExtensionsSettingsSubspaceState, getData } from '../SharedSettingsSpace/ExtensionsSettingsSubspaceShared';

interface ExtensionsServerSettingsSubspaceOwnProps {
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
}

export class ExtensionsServerSettingsSubspaceComponent extends React.PureComponent<ExtensionsServerSettingsSubspaceOwnProps, ExtensionsSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: ExtensionsSettingsSubspaceState = {
    isServerPage: true,
    isMultiSite: undefined,
    hasDataToRender: false,
    hasError: false,
    dashExtServerSettings: undefined,
    dashExtSiteSettings: undefined,
    extsvcServerSettings: undefined,
    analyticsExtensionsServerSettings: undefined,
    analyticsExtensionsSiteSettings: undefined,
    siteSettingsForSiteAdmin: undefined,
  };

  public constructor(props: ExtensionsServerSettingsSubspaceOwnProps) {
    super(props);
    this.state = {
      ...this.initialState,
      isMultiSite: props.isSessionMultiSite
    };
  }

  public componentDidMount() {
    getData(
      (newState) => { this.updateState(newState as ExtensionsSettingsSubspaceState); },
      () => { this.updateState({hasError: true}); }
    );
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if (!_.isUndefined(this.state.dashExtServerSettings)
      && !_.isUndefined(this.state.dashExtSiteSettings)
      && (!_.isUndefined(this.state.siteSettingsForSiteAdmin) || !FeatureFlags.prepExtensionsEinstein)
      && (!_.isUndefined(this.state.analyticsExtensionsSiteSettings))
      && (!_.isUndefined(this.state.analyticsExtensionsServerSettings))
    ) {
      this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'server-default'} urls={undefined}/>;
    }

    return (
      <div className={subspaceStyle}>
        <ExtensionsSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof ExtensionsSettingsSubspaceState>(newState: Pick<ExtensionsSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }
}
